import React from 'react';
import Head from 'next/head';
import { useTranslation } from 'next-i18next';
import { GetServerSidePropsContext } from 'next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { API, APIRoutes } from '@utils/api';
import GlobalError from '@components/GlobalError';

import Employer from '@components/EmployerDetails';

function EmployerPage({ slug, error, offers }) {
  const { t } = useTranslation(['common', 'employerProfile']);

  return (
    <>
      <Head>
        <title>
          {error ? t('Page Not Found', { ns: 'common' }) : `${slug.employerProfile.name} - ${t('page-title')}`}
        </title>
      </Head>
      {error ? (
        <GlobalError message={t('Page Not Found', { ns: 'common' })} />
      ) : (
        <Employer slug={slug} offers={offers} />
      )}
    </>
  );
}

export async function getServerSideProps({ locale, params, query }: GetServerSidePropsContext) {
  const getTranslations = serverSideTranslations(locale, [
    'homepage',
    'navbar',
    'footer',
    'bottomBanner',
    'autocomplete',
    'common',
    'employerProfile',
  ]);
  try {
    const { data: slug } = await API.get(APIRoutes.employer(params.slug));
    const { data: offers } = await API.get(APIRoutes.employerOffers({ slug: params.slug, page: query.page || 1 }));

    return {
      props: {
        ...(await getTranslations),
        slug,
        offers,
        error: false,
      },
    };
  } catch (error) {
    return {
      props: {
        ...(await getTranslations),
        slug: {},
        offers: {},
        error: true,
      },
    };
  }
}
export default EmployerPage;
